


































































































































import 'github-markdown-css/github-markdown.css';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { VueGitalkOptions } from '@/types';
import AxiosGitHub, { CONST, ClientComments, ClientReactions } from '@/api';
import { IssueResponse, CommentsResponse } from '@/api/types';

import GtInit from '@/components/GtInit.vue';
import GtAvatar from '@/components/GtAvatar.vue';
import GtButton from '@/components/GtButton.vue';
import GtSvgMap from '@/components/svg/GtSvgMap.vue';
import GtComment from '@/components/GtComment.vue';

@Component<VueGitalk>({
  components: {
    GtInit,
    GtAvatar,
    GtButton,
    GtSvgMap,
    GtComment,
  },
  mounted() {
    const storedComment = window.localStorage.getItem(CONST.GT_COMMENT);
    if (storedComment) {
      this.value = decodeURIComponent(storedComment);
      window.localStorage.removeItem(CONST.GT_COMMENT);
    }
  },
})
export default class VueGitalk extends Vue {
  @Prop({ type: Object, required: true }) readonly options!: VueGitalkOptions

  setting: Required<VueGitalkOptions> = Object.freeze({
    id: window.location.href,
    number: -1,
    labels: ['vue-github-comment'],
    title: window.document.title,
    body: window.location.href,
    perPage: 10,
    pagerDirection: 'last',
    createIssueManually: false,
    distractionFreeMode: false,
    proxy: 'https://cors-anywhere.herokuapp.com/https://github.com/login/oauth/access_token',
    enableHotKey: true,
    // 合併 props
    ...this.options,
  })

  /**
   * AxiosGitHub instance
   */
  axiosGitHub: AxiosGitHub = new AxiosGitHub(this.setting)

  /**
   * 我還不知道這是什麼
   */

  issue: any = null

  /**
   * textarea 輸入內容
   */
  value: string = ''

  /**
   * 預覽內容
   */
  previewHtml: string = ''

  /**
   * textarea 使否被 focus
   * 在 options.distractionFreeMode === false 時，永遠為 false
   */
  isInputFocused: boolean = false

  /**
   * 是否為預覽模式
   */
  isPreview: boolean = false

  /**
   * 排序方式 評論排序方式
   */
  pagerDirection:
    VueGitalkOptions['pagerDirection'] = this.setting.pagerDirection

  /**
   * 管理者名單
   */
  get admin() {
    return this.options.admin.map((admin) => `@${admin}`).join(' ');
  }

  /**
   * 初始化中
   */
  get isIniting() {
    return this.axiosGitHub.isIniting;
  }

  /**
   * 回應總數
   */
  get commentsCount() {
    return this.axiosGitHub.commentsCount;
  }

  get issueUrl() {
    const { issue } = this.axiosGitHub;
    return issue && issue.html_url;
  }

  get user(): IssueResponse['user'] | null {
    return this.axiosGitHub.user;
  }

  get comments(): ClientComments[] {
    const comments = [...this.axiosGitHub.comments];
    if (this.setting.pagerDirection === 'last' && this.user) {
      comments.reverse();
    }
    return comments;
  }

  get isLoadOver() {
    return this.axiosGitHub.isLoadOver;
  }

  get isLoadMore() {
    return this.axiosGitHub.isLoadMore;
  }

  get isCreating() {
    return this.axiosGitHub.isCreating;
  }

  /**
   * 依照行數計算 textarea 修正高度
   */
  get textareaFixStyle() {
    const row = this.value.split('\n').length;
    return row > 5
      ? {
        height: `${Math.min(row * 18, 240)}px`,
      }
      : null;
  }

  /** 登入 */
  handleLogin() {
    if (this.user) { return; }
    window.localStorage.setItem(
      CONST.GT_COMMENT,
      encodeURIComponent(this.value),
    );
    this.axiosGitHub.login();
  }

  /** 登出 */
  handleLogout() {
    if (!this.user) { return; }
    this.axiosGitHub.logout();
    this.axiosGitHub = new AxiosGitHub(this.setting);
  }

  /** 建立 Issue */
  handleIssueCreate() {
    this.axiosGitHub.getIssueCreate();
  }

  handleCommentFocus() {
    const { distractionFreeMode } = this.setting;
    if (!distractionFreeMode) { return; }
    this.isInputFocused = true;
  }

  handleCommentBlur() {
    this.isInputFocused = false;
  }

  /**
   * 快捷鍵送出
   */
  handleCommentKeyDown(e: KeyboardEvent) {
    const { enableHotKey } = this.setting!;
    if (enableHotKey && (e.metaKey || e.ctrlKey)) {
      this.handleCommentCreate();
    }
  }

  /**
   * 預覽
   */
  handleCommentPreview() {
    const { value } = this;
    if (!this.isPreview) {
      this.axiosGitHub.getCommentPreview(value)
        .then((res) => { this.previewHtml = res; });
    }
    this.isPreview = !this.isPreview;
    this.$nextTick(() => {
      (this.$refs.textarea as HTMLTextAreaElement).focus();
    });
  }

  handleCommentCreate() {
    if (!this.value.length) {
      return;
    }
    this.isPreview = false;
    this.previewHtml = '';
    this.axiosGitHub.createComment(this.value)
      .then(() => { this.value = ''; });
  }

  /**
   * 回應指定回應
   */
  handleCommentReply(comment: CommentsResponse) {
    const { value } = this;
    const replyCommentBody = comment.body;
    let replyCommentArray = replyCommentBody.split('\n');
    replyCommentArray.unshift(`@${comment.user.login}`);
    replyCommentArray = replyCommentArray.map((t) => `> ${t}`);
    replyCommentArray.push('');
    replyCommentArray.push('');
    if (value) replyCommentArray.unshift('');
    this.value += replyCommentArray.join('\n');

    this.$nextTick(() => {
      (this.$refs.textarea as HTMLTextAreaElement).focus();
    });
  }

  /**
   * 載入更多留言
   */
  handleCommentLoad() {
    this.axiosGitHub.getCommentLoad();
  }

  /**
   * 表情回應
   */
  handleReaction(
    data: {
      content: keyof ClientReactions,
      comment: ClientComments
    },
  ) {
    if (!this.user) { return; }
    this.axiosGitHub.postReaction(data);
  }

  getInit() {
    this.axiosGitHub.getInit();
  }
}
